import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const immunizationsSlice = createSlice({
  name: "entities/patient-stats/immunizations-slice",
  initialState,
  reducers: {
    setImmunizations: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setImmunizations } = immunizationsSlice.actions;

export default immunizationsSlice.reducer;
